(function(w,d,$){
  'use strict';
  if(!$) return;

  var api=w.CartJS=w.CartJS||{};
  var cart=api.cart=api.cart||{};
  var settings={dataAPI:true,requestBodyClass:null,moneyFormat:null,moneyWithCurrencyFormat:null};
  var bound=false;

  function copyCart(next){
    next=next||{};
    Object.keys(cart).forEach(function(key){ if(key!=='items') delete cart[key]; });
    Object.keys(next).forEach(function(key){ cart[key]=next[key]; });
    if(!cart.items) cart.items=[];
    return cart;
  }

  function money(cents,format){
    if(w.Shopify&&typeof w.Shopify.formatMoney==='function') return w.Shopify.formatMoney(cents,format);
    return cents;
  }

  function render(){
    var values={
      item_count:cart.item_count||0,
      total_price:cart.total_price||0,
      total_price_money:money(cart.total_price||0,settings.moneyFormat),
      total_price_money_with_currency:money(cart.total_price||0,settings.moneyWithCurrencyFormat)
    };
    $('[data-cart-render]').each(function(){
      var key=$(this).attr('data-cart-render');
      if(Object.prototype.hasOwnProperty.call(values,key)) $(this).text(values[key]);
    });
  }

  function refreshHeader(){
    if(w.Shopify&&typeof w.Shopify.onCartUpdate==='function'){
      w.Shopify.onCartUpdate(cart);
    }else if(w.Shopify&&typeof w.Shopify.updateCartInfo==='function'){
      w.Shopify.updateCartInfo(cart,'#cart-info #cart-content');
    }
  }

  function request(url,data,callbacks){
    callbacks=callbacks||{};
    $(d).trigger('cart.requestStarted',[cart]);
    if(settings.requestBodyClass) $('body').addClass(settings.requestBodyClass);
    return $.ajax({
      type:callbacks.type||'POST',
      url:url,
      data:data||{},
      dataType:'json',
      success:function(next){
        copyCart(next);
        render();
        refreshHeader();
        if(typeof callbacks.success==='function') callbacks.success(cart);
      },
      error:function(xhr){
        if(typeof callbacks.error==='function') callbacks.error(xhr);
      },
      complete:function(){
        if(settings.requestBodyClass) $('body').removeClass(settings.requestBodyClass);
        $(d).trigger('cart.requestComplete',[cart]);
        if(typeof callbacks.complete==='function') callbacks.complete(cart);
      }
    });
  }

  function bindDataAPI(){
    if(bound||!settings.dataAPI) return;
    bound=true;
    $(d).on('click.iceCartLite','[data-cart-remove]',function(e){
      e.preventDefault();
      var line=parseInt($(this).attr('data-cart-remove'),10);
      if(line>0) api.removeItem(line);
    });
    $(d).on('click.iceCartLite','[data-cart-remove-id]',function(e){
      e.preventDefault();
      var id=$(this).attr('data-cart-remove-id');
      if(id) api.removeItemById(id);
    });
  }

  api.init=function(initial,options){
    settings=$.extend(settings,options||{});
    copyCart(initial||{});
    render();
    bindDataAPI();
    return api;
  };
  api.configure=function(options){ settings=$.extend(settings,options||{}); return api; };
  api.removeItem=function(line,options){ return request('/cart/change.js',{line:line,quantity:0},options); };
  api.removeItemById=function(id,options){ return request('/cart/change.js',{id:id,quantity:0},options); };
  api.updateItem=function(line,quantity,properties,options){
    var data={line:line,quantity:quantity};
    properties=properties||{};
    Object.keys(properties).forEach(function(key){ data['properties['+key+']']=properties[key]; });
    return request('/cart/change.js',data,options);
  };
  api.clear=function(options){ return request('/cart/clear.js',{},options); };
  api.getCart=function(options){ options=options||{}; options.type='GET'; return request('/cart.js',{},options); };
}(window,document,window.jQuery));
